import { BootstrapDialog } from '@components/shared/BootstrapDialog';
import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

export default function CustomLensModal({
  open,
  onOpenChange,
  handleContinue,
  instructions,
  setInstructions,
}) {
  return (
    <BootstrapDialog open={open} onClose={() => onOpenChange(false)}>
      <DialogTitle sx={{ fontWeight: 600 }}>Add Custom Lens / Framework</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => onOpenChange(false)}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <Divider />
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Define your custom coding framework or lens. Provide detailed instructions on how you want
          the code to be analyzed or generated.
        </Typography>
        {/* Top Guidelines Section */}
        <Box
          sx={{
            border: '1px solid',
            borderColor: 'divider',
            bgcolor: 'action.hover',
            borderRadius: 2,
            p: 2.5,
            mb: 3,
          }}
        >
          <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
            Top guidelines
          </Typography>
          <Typography variant="body2" color="text.secondary">
            - Describe how you want the analysis done in plain English.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            - If you already use codes/themes, or a framework describe them.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            - Say how to organize results and what to include.
          </Typography>
        </Box>
        <Stack spacing={1.2} sx={{ mb: 3 }}>
          <Typography variant="body2" fontWeight={500}>
            Instructions <span style={{ color: 'text.secondary' }}>(required)</span>
          </Typography>
          <TextField
            id="instructions"
            multiline
            minRows={8}
            fullWidth
            placeholder={`Things you can include:\n\n> Priorities: what to focus on (topics, questions, audiences).\n> A list of themes, concepts or qualitative codes to look for\n> Description of the purpose or the intent of the analysis.\n\nExample:\n"Cluster responses into major themes about onboarding. Use my codes: Access, Usability, Support, Trust; create subthemes if patterns emerge. Separate findings for new vs. returning users. Include 1–2 quotes per subtheme and mark prevalence (low/med/high)."`}
            value={instructions}
            onChange={(e) => setInstructions(e.target.value)}
          />

          {/* <Button
            variant="outlined"
            fullWidth
            startIcon={<Sparkles size={18} />}
            onClick={handleEnhancePrompt}
            disabled={!instructions.trim() || isEnhancing}
          >
            {isEnhancing ? 'Enhancing...' : 'Enhance Prompt with AI'}
          </Button> */}
        </Stack>
        {/* Help Links */}
        {/* <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} sx={{ mb: 3 }}>
          <Button
            variant="default"
            startIcon={<ImportContactsIcon size={18} />}
            onClick={() => window.open('https://example.com', '_blank')}
            endIcon={<LaunchOutlinedIcon size={18} />}
          >
            Read the guide
          </Button>
          {/* <Button
            variant="default"
            startIcon={<VideocamOutlinedIcon size={18} />}
            onClick={() => console.log('Watch walkthrough clicked')}
            endIcon={<LaunchOutlinedIcon size={18} />}
          >
            Watch a short walkthrough
          </Button>
        </Stack> */}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="default" onClick={() => onOpenChange(false)}>
          Cancel
        </Button>
        <Button variant="contained" onClick={handleContinue} disabled={!instructions.trim()}>
          Continue
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
}
